// extracted by mini-css-extract-plugin
export default {"root":"StartTimeInterval_root__LMQLZ","label":"StartTimeInterval_label__gYCRy","option":"StartTimeInterval_option__UpHQ5"};